var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95 1.33333C1.59398 1.33333 1.3 1.63486 1.3 2C1.3 2.17681 1.36848 2.34638 1.49038 2.4714C1.61228 2.59643 1.77761 2.66667 1.95 2.66667H9.1V1.33333H1.95ZM10.4 2.66667V0.666667C10.4 0.298477 10.109 0 9.75 0H1.95C0.876015 0 0 0.898477 0 2V10C0 11.1015 0.876015 12 1.95 12H11.05C11.409 12 11.7 11.7015 11.7 11.3333V9.33333H12.35C12.709 9.33333 13 9.03486 13 8.66667V6C13 5.63181 12.709 5.33333 12.35 5.33333H11.7V3.33333C11.7 2.96514 11.409 2.66667 11.05 2.66667H10.4ZM1.95 4C1.72644 4 1.50683 3.96063 1.3 3.88562V10C1.3 10.3651 1.59398 10.6667 1.95 10.6667H10.4V9.33333H9.75C8.67601 9.33333 7.8 8.43486 7.8 7.33333C7.8 6.8029 8.00545 6.29419 8.37114 5.91912C8.73684 5.54405 9.23283 5.33333 9.75 5.33333H10.4V4H1.95ZM9.75 6.66667C9.57761 6.66667 9.41228 6.73691 9.29038 6.86193C9.16848 6.98695 9.1 7.15652 9.1 7.33333C9.1 7.69848 9.39398 8 9.75 8H11.7V6.66667H9.75Z",
    fill: "#9B96FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7786e3c8.svg";
export { ForwardRef as ReactComponent };